module.exports = __webpack_public_path__ + "static/media/myImage1.b6759f40.png";